/*!

=========================================================
* Paper Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import firebase from 'firebase/app';
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.2.0";
import "assets/demo/demo.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";

import AdminLayout from "layouts/Admin.js";

const hist = createBrowserHistory();
const firebaseConfig = {
    apiKey: "AIzaSyAgWNflaMvmtu8XZEvD1nGnbyaMzoqdSTc",
    authDomain: "shallow-sleep.firebaseapp.com",
    projectId: "shallow-sleep",
    storageBucket: "shallow-sleep.appspot.com",
    messagingSenderId: "760130984134",
    appId: "1:760130984134:web:d9ac1193cba1a096cfdfc7",
    measurementId: "G-LD24MGYS5K"
};

firebase.initializeApp(firebaseConfig);

ReactDOM.render(
  <Router history={hist}>
    <Switch>
      <Route path="/" render={(props) => { return (<div> <Redirect to="/dashboard/" /> <AdminLayout {...props} /> </div>)}} />
    </Switch>
  </Router>,
  document.getElementById("root")
);
